import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { ArrowLinkListItem } from './ArrowLinkListItem/ArrowLinkListItem'
import { DetailsLink } from '../../DetailsLink/DetailsLink'
import { ErrorBoundary } from '../../ErrorBoundary/ErrorBoundary'

import './ArrowLinkList.css'

class ArrowLinkList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggleListClass: 'collapsed',
            expand: false,
            moreTitle: this.props.moreTitle
        }
    }

    toggleList = () => {
        const { moreTitle, lessTitle } = this.props

        if (this.state.expand) {
            this.setState({
                toggleListClass: 'collapsed',
                moreTitle: moreTitle,
                expand: false
            })
        } else {
            this.setState({
                toggleListClass: 'expanded',
                moreTitle: lessTitle,
                expand: true
            })
        }
    }

    expandList = () => {
        const { lessTitle } = this.props

        if (!this.state.expand) {
            this.setState({
                toggleListClass: 'expanded',
                moreTitle: lessTitle,
                expand: true
            })
        }
    }

    render() {
        const { links, onClick, dark } = this.props
        const { toggleListClass, moreTitle } = this.state
        const expandClass = links.length > 5 ? 'expand-list' : ''
        const className = dark ? 'dark' : ''

        return (
            <Fragment>
                <div
                    className={`arrow-link-list arrow-link-list--${className} arrow-link-list--${toggleListClass} arrow-link-list__toggle ${expandClass}`}
                    onClick={this.expandList}
                >
                    {links.map((linkItem, i) => (
                        <ErrorBoundary key={i}>
                            <ArrowLinkListItem
                                item={linkItem}
                                onClick={onClick}
                                className={className}
                            />
                        </ErrorBoundary>
                    ))}
                </div>
                <div
                    className={`arrow-link-list__toggle arrow-link-list__toggle--${toggleListClass}`}
                >
                    {links.length > 5 && (
                        <DetailsLink
                            text={moreTitle}
                            onDetailsClick={this.toggleList}
                            white={dark}
                        />
                    )}
                </div>
            </Fragment>
        )
    }
}

ArrowLinkList.propTypes = {
    links: PropTypes.array.isRequired,
    moreTitle: PropTypes.string,
    lessTitle: PropTypes.string,
    onClick: PropTypes.func,
    dark: PropTypes.bool
}

export { ArrowLinkList }
